import React, {useEffect, useState} from 'react';
import {
  Dimensions,
  Modal,
  StyleSheet,
  TouchableOpacity,
  Text,
  View,
  ScrollView,
} from 'react-native';
import {globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import CommonModal from '../../../commonComponents/commonModal';
import CustomButton from '../../../commonComponents/CustomButton';
import {TEST_API} from '../../../utils/apiUrl';
import {Network} from '../../../utils/network';
import EventDetailsBox from '../../event/childComponents/EventDetailsBox';
import ClubEventDetail from './clubEventDetail';
import ClubImageCard from './clubImageCard';
import ClubMarketOptions from './clubMarketOptions';
import ClubSettlementResponse from './ClubSettlementResponse';
import {globalConst} from "../../../utils/globalConstant";

const ClubCreateFinal = ({clubEventDetails, clubId, navigation}) => {
  const [isResponse, setIsShowResponse] = useState(null);
  const onSubmit = async () => {
    const req = {
      ...clubEventDetails,
      options: clubEventDetails.optionsArr,
      club_id: clubId,
      starts_at: clubEventDetails.start_time,
      ends_at: clubEventDetails.end_time,
    };
    delete req.optionsArr;
    delete req.start_time;
    delete req.end_time;
    delete req.event_img;

    const res = await Network.createClub({clubId: clubId}, req, true);

    setIsShowResponse(res?.data);
  };

  const onSuccessfulResponse = isError => {
    setIsShowResponse(null);
    if (!isError) {
      navigation.pop();
    }
  };
  return (
    <View style={{flex: 1}}>
      <Text
        style={{
          borderBottomWidth: 0.1,
          paddingVertical: 6,
          textAlign: 'center',
          color: Colors.blue1,
          backgroundColor: 'rgba(10, 87, 255, 0.1);',
        }}>
        Preview: Your event will look like this to user
      </Text>
      <View style={{paddingVertical: 10}}>
        <ClubImageCard
          title={clubEventDetails?.title}
          titleImg={TEST_API + clubEventDetails?.event_img}
        />
        <ClubMarketOptions
          onOptionClick={() => {}}
          clubmarketOptions={clubEventDetails?.options || []}
        />
      </View>
      <View>
        <ClubEventDetail clubEventDetails={clubEventDetails} />
        <EventDetailsBox
          text={'Market will be settled as per rules mentioned here.'}
          title={'Market Resolution'}
          eventInfo={{resolution: clubEventDetails?.rules}}
          isNews={false}
        />
      </View>
      <View style={[globalStyle.bottomAbsBtnBar, {alignSelf: 'flex-end'}]}>
        <CustomButton
          btnText={'Proceed'}
          btnType="normalBlue"
          onBtnClick={onSubmit}
        />
      </View>
      <CommonModal
        onModalCallBack={onSuccessfulResponse}
        customModalStyle={[globalStyle.modalView]}
        showModal={isResponse ? true : false}>
        <ClubSettlementResponse
          clubOrderResponse={isResponse}
          onDoneClick={()=>{
              setTimeout(() => {
                  onSuccessfulResponse();
              }, globalConst?.buttonTimer);
          }}
        />
      </CommonModal>
    </View>
  );
};

export default ClubCreateFinal;
